import React from 'react'
import { Col } from 'react-bootstrap'
import Money from '../Money/Money'
import { toMoneyDynamic } from 'src/utils/utilities'
import { Paragraph } from 'src/components/index'

interface Props {
  label: string
  value: number
}

export const TotalInfo = ({ label, value }: Props) => {
  return (
    <Col style={{ alignSelf: 'flex-end' }}>
      <div className={'justify-center column'}>
        <span>{label}</span>
        <Paragraph bold size="extraBig" dim>
          {toMoneyDynamic(Number(value))}
        </Paragraph>
      </div>
    </Col>
  )
}
